import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  static targets = ["code", "message", "form", "discountDisplay"]
  static values = {
    applyUrl: String,
    enrollmentId: String
  }

  apply(event) {
    event.preventDefault()
    this.clearErrors()

    if (!this.codeTarget.value.trim()) {
      // this.showError("Discount code cannot be blank")
      return
    }

    this.formTarget.classList.add("processing")
    this.messageTarget.innerHTML = '<div class="alert alert-info">Applying discount...</div>'

    fetch(this.applyUrlValue, {
      method: "POST",
      body: new URLSearchParams({
        discount_code: this.codeTarget.value,
        enrollment_id: this.enrollmentIdValue
      }),
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      }
    })
      .then(response => {
        if (!response.ok) throw new Error(response.statusText)
        return response.text()
      })
      .then(html => Turbo.renderStreamMessage(html))
      .catch(error => {
        this.showError(error.message || "Failed to apply discount. Please try again.")
      })
      .finally(() => {
        this.formTarget.classList.remove("processing")
        this.messageTarget.innerHTML = ''
      })
  }

  clearErrors() {
    this.messageTarget.innerHTML = ''
    this.codeTarget.classList.remove("is-invalid")
  }

  showError(message) {
    this.messageTarget.innerHTML = `<div class="alert alert-danger">${message}</div>`
    this.codeTarget.classList.add("is-invalid")
    this.codeTarget.focus()
  }
}
